import React from 'react';
import Vista from './layout/Vista';
import CallFilterBar from './call/FilterBar';
import CallListRow from './call/ListRow';
import { groupCalls } from './call/call-utils';

export default function CallLog({ initialNomeCognome = '', initialDateRange = [null, null] }) {
    
    const processDateRangeParams = (params) => {
        const processedParams = { ...params };
        const [start, end] = params.dateRange ?? initialDateRange;
        if (start) processedParams.data_da = start.toISOString().split('T')[0];
        if (end) processedParams.data_a = end.toISOString().split('T')[0];
        delete processedParams.dateRange;
        return processedParams;
    };

    return (
        <Vista
            apiCallEndpoint={"/chiamate"}
            initialFilterParams={{ nome_cognome: initialNomeCognome, dateRange: initialDateRange }}
            processParams={processDateRangeParams}
            FilterBarComponent={CallFilterBar}
            ListRowComponent={CallListRow}
            groupTransform={groupCalls}
            endMessage="Non ci sono altre chiamate"
        />
    );
}